module.exports = __webpack_public_path__ + "media/images/cross-0caa8fcc.png";